import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { LoginCallback, RequireAuth } from "@/auth";
import { Layout } from "@/components/Layout";
import { ChainDetailPage } from "@/pages/ChainDetailPage";
import { ChainsListPage } from "@/pages/ChainsListPage";
import { LoginPage } from "@/pages/LoginPage";

// Lazy-load the 3D viewer so three.js + react-force-graph-3d (~1 MB of
// JS pre-gzip) only ships when the user actually opens the network page.
const ChainGraph3DPage = lazy(() =>
  import("@/pages/ChainGraph3DPage").then((mod) => ({ default: mod.ChainGraph3DPage })),
);

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/callback" element={<LoginCallback />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/chains" replace />} />
        <Route path="chains" element={<ChainsListPage />} />
        {/* Order matters: `graph-3d` must be declared BEFORE the
            `:chainId` catch-all so the router doesn't route the
            literal "graph-3d" to the detail page. */}
        <Route
          path="chains/graph-3d"
          element={
            <Suspense
              fallback={
                <div className="card p-6 text-center text-slate-500">
                  Loading 3D network…
                </div>
              }
            >
              <ChainGraph3DPage />
            </Suspense>
          }
        />
        <Route path="chains/:chainId" element={<ChainDetailPage />} />
        <Route path="*" element={<Navigate to="/chains" replace />} />
      </Route>
    </Routes>
  );
}
